import React from "react"
import PropTypes from "prop-types"
import ItemNameValueShape from "../../state/shapes/ItemNameValueShape"
import Widget from "../layout/widget/Widget"
import GaugeChart from "../charts/generic/GaugeChart"
import { CHARTS } from "../../constants"

function TemperatureCheckResponseRate({ exportEndpoint, appliedFilters, data, subtitleKey }) {
  const stopsValues = [
    [0.15, CHARTS.trafficLightColours.red], // red
    [0.5, CHARTS.trafficLightColours.amber], // yellow
    [0.75, CHARTS.trafficLightColours.green] // green
  ]
  const titleKey = "Widgets.TemperatureCheckResponseRate.Title"
  return (
    <Widget
      columns={1}
      helpKey="Widgets.TempCheckRate.Help"
      titleKey={titleKey}
      exportEndpoint={exportEndpoint}
      appliedFilters={appliedFilters}
      subtitleKey={subtitleKey}
    >
      <GaugeChart data={data} stopsValues={stopsValues} titleKey={titleKey} subtitleKey={subtitleKey}/>
    </Widget>
  )
}

TemperatureCheckResponseRate.propTypes = {
  appliedFilters: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.shape(ItemNameValueShape).isRequired,
  exportEndpoint: PropTypes.string.isRequired,
  subtitleKey: PropTypes.string
}

export default TemperatureCheckResponseRate



// WEBPACK FOOTER //
// ./src/components/widgets/TemperatureCheckResponseRate.jsx